import React from "react";

import { Circle, Container, Count, Item, Label } from "./styles";
import { WithTranslation, withTranslation } from "react-i18next";

type Props = {
  scheduled?: number;
  completed?: number;
  streak?: number;
} & WithTranslation;

const Summary = ({ scheduled = 0, completed = 0, streak = 0, t }: Props) => {
  const translate: (key: string) => string = t;
  return (
    <Container>
      <Item>
        <Count>{scheduled}</Count>
        <Circle scheduled />
        <Label>{translate("labels.workout-scheduled")}</Label>
      </Item>

      <Item>
        <Count>{completed}</Count>
        <Circle completed />
        <Label>{translate("labels.workout-completed")}</Label>
      </Item>

      <Item>
        <Count>{streak}</Count>
        <Circle streak />
        <Label>{translate("labels.daily-streak")}</Label>
      </Item>
    </Container>
  );
};

export default withTranslation()(Summary);
